import { render, staticRenderFns } from "./iconDeposit.vue?vue&type=template&id=bf20b4ca&scoped=true"
import script from "./iconDeposit.vue?vue&type=script&lang=js"
export * from "./iconDeposit.vue?vue&type=script&lang=js"
import style0 from "./iconDeposit.vue?vue&type=style&index=0&id=bf20b4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf20b4ca",
  null
  
)

export default component.exports